export default __webpack_public_path__ + "static/media/logo-black.672823c9.png";